import React, { FunctionComponent, useRef, useEffect, useState } from 'react';
import { Button, IButtonProps } from '../button/button';
import styles from './image-with-button.module.scss';

export interface IImageWithButtonProps {
  image: {
    url: string;
    description: string;
  };
  button: IButtonProps[];
  positionAbsolute: boolean;
}

export const ImageWithButton: FunctionComponent<IImageWithButtonProps> = props => {
  const { button, image, positionAbsolute } = props;

  const [moveImageUp, setMoveImageUp] = useState(false);
  const buttonRef = useRef<HTMLDivElement>(null);
  const imageRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const buttonElem = buttonRef.current;

    buttonElem?.addEventListener('mouseenter', moveImageUpHandler);
    buttonElem?.addEventListener('mouseleave', moveImageDownHandler);
    return (): void => {
      buttonElem?.removeEventListener('mouseover', moveImageUpHandler);
      buttonElem?.removeEventListener('mouseleave', moveImageDownHandler);
    };
  }, []);

  const moveImageUpHandler = (): void => setMoveImageUp(true);
  const moveImageDownHandler = (): void => setMoveImageUp(false);

  return (
    <div
      className={`${styles.wrapper} ${positionAbsolute &&
        styles.wrapperAbsolute}`}
    >
      <img
        className={`${moveImageUp && styles.imageUp}`}
        src={image.url}
        alt={image.description}
        ref={imageRef}
      />
      <div className={styles.buttonWrapper} ref={buttonRef}>
        {button.map((item, i) => (
          <Button {...item} key={i} />
        ))}
      </div>
    </div>
  );
};
